import { Controller } from "@hotwired/stimulus"

// Master checkbox: tilda/destilda todos los checkboxes de la sección
// (card actual). Selecciona solo los inputs cuyo name empieza con
// "field_checks[" — ignora los _destroy, is_retencion, etc.
export default class extends Controller {
  static targets = ["master"]

  toggle() {
    const checked = this.masterTarget.checked
    this.element.querySelectorAll('input[type="checkbox"][name^="field_checks["]').forEach(cb => {
      cb.checked = checked
    })
  }
}
